import { map } from 'lodash';
import aisle from './aisle';
import common from './common';
import growz from './growz';
import publicRoutes from './public';
import stores from './stores';
import onboarding from './onboarding';

export default [
  ...aisle,
  ...common,
  ...onboarding,
  ...growz,
  ...stores,
  ...map(publicRoutes, (i) => ({ ...i, publicRoute: true })),
];
